import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import TierFilter from './TierFilter';
import CellName from 'components/common/CellName';
import SelectUsersFilter from './SelectUsersFilter';

import useStyles from '../style';

const UsersHeader: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.usersHeader}>
      <CellName name="photo" />
      <CellName name="name">{t('name')}</CellName>
      <CellName name="role">
        <SelectUsersFilter filterKey="role" />
      </CellName>
      <CellName name="tier">
        <TierFilter />
      </CellName>
      <CellName name="finance-status">
        <SelectUsersFilter filterKey="financeStatus" />
      </CellName>
    </div>
  );
};

export default UsersHeader;
